export function isDevice() {
    let userAgent = getUserAgent();
    if (userAgent.match(/Android|webOS|iPhone|iPad|iPod|bada|Symbian|Palm|CriOS|BlackBerry|IEMobile|WindowsMobile|Opera Mini/i)) {
        return true;
    }

    return false;
}

export function getUserAgent() {
    return window.navigator.mockUserAgent || window.navigator.userAgent;
}


// WEBPACK FOOTER //
// ./src/utils.js